export default function SetAccountKey(state = 'account_key', action) {
  switch (action.type) {
    case 'SET_ACCOUNT_KEY': {
      return action.payload
    }
    default:
      return state
  }
}
